import { Box, Button, FileInput, Input, LoadingOverlay, Paper, Select, SimpleGrid, Space, Text, TextInput, Title } from '@mantine/core'
import React, { memo, useEffect, useState } from 'react'
import useFetch from '../../../../Customhooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from '../../../../Constants/constant';
import { notifications } from '@mantine/notifications';
import classes from '../ManageDbVersion.module.css'
import { YearPickerInput } from '@mantine/dates';


const AddVerticals = () => {
    const navigate = useNavigate();
    const [dbVersion, setdbVersion] = useState<any>('');
    const [dbDescription, setdbDescription] = useState<string>('');
    const [value, setValue] = useState<Date | null>(null);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const token = localStorage.getItem("token")
    const { id } = useParams();
    const method = id ? 'PUT' : 'POST'
    const url = id ? `${baseUrl}admin/database-version/update/${id}` : `${baseUrl}admin/database-version/add`
    const {
        data: getData,
        loading: detailLoading,
        error: getError,
        fetchData: postvertical,
    } = useFetch({
        method: method,
        referrerPolicy: "no-referrer",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
        body: JSON.stringify({
            db_version: dbVersion,
            db_year: value ? new Date(value).getFullYear() : null,
            db_description: dbDescription,
        }),
    });
    const {
        data: getfieldData,
        loading: getfieldLoading,
        error: getfielderror,
        fetchData: getfield,
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "token": token
        },
    });
    useEffect(() => {
        if (id) {
            getfield(`${baseUrl}admin/database-version/${id}`)
        }

    }, [id])
    useEffect(() => {
        if (getfieldData?.data?.rows?.length) {
            setdbVersion(getfieldData?.data?.rows[0]?.db_version)
            setdbDescription(getfieldData?.data?.rows[0]?.db_description)
            const year = getfieldData?.data?.rows[0]?.db_year;
            setValue(year ? new Date(year, 0, 1) : null);
        }
    }, [getfieldData])

    const handleChange = (field: string, value: any | null) => {
        if (field === "db_version") {
            setdbVersion(value as number);
        }
        if (field === "db_description") {
            setdbDescription(value as string);
        }
        if (field === "year_pick") {
            setValue(value);
        }

        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    const validateFields = () => {
        let newErrors: Record<string, string> = {};

        if (!dbVersion) {
            newErrors.db_version = "Database Version is Required";
        }
        if (!value) {
            newErrors.year_pick = "Year is Required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    const handlesave = async () => {
        if (!validateFields()) return
        await postvertical(url)
    }

    useEffect(() => {
        const showNotification = (type: any, title = "An error occurred") => {
            notifications.show({
                title,
                message: type === 'success'
                    ? "Transport data saved successfully."
                    : "Something went wrong. Please try again.",
                color: type === 'success' ? "green" : "red",
                classNames: classes,
            });
        };

        if (getData?.errors || getError) {
            showNotification('error', getData?.message || getError?.message);
            return;
        }

        if (getData && !getData?.errors) {
            navigate('/manage-db-version');
        }
    }, [getData, getError, navigate, classes]);

    return (
        <>

            <LoadingOverlay
                visible={getfieldLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            <Paper shadow="xs" p="xs" radius="md">
                <Box ml={5}>
                    <Title order={4}>Add DataBase Version</Title>
                    <Space h="lg" />
                    <Text>DataBase Version Details</Text>
                    <Space h="xs" />
                    <SimpleGrid cols={4}>
                        <TextInput
                            variant='filled'
                            value={dbVersion}
                            onChange={(e) => handleChange("db_version", e.target.value)}
                            label="DataBase Version"
                            withAsterisk
                            placeholder="Enter DataBase Version"
                            radius={6}
                            error={errors.db_version}
                        />
                        <YearPickerInput
                            label="Version Year"
                            withAsterisk
                            variant='filled'
                            placeholder="Version Year"
                            value={value}
                            onChange={(value) => handleChange("year_pick", value)}
                            valueFormat="YYYY"
                            clearable
                            error={errors.year_pick}
                        />
                        <TextInput
                            label="DataBase Description"
                            placeholder="Enter DataBase Description"
                            variant='filled'
                            value={dbDescription}
                            onChange={(e) => handleChange("db_description", e.target.value)}
                            radius={6}
                        />
                    </SimpleGrid>
                    <Space h="xl" />
                    <SimpleGrid cols={6}>
                        <Button
                            variant="default"
                            radius={6}
                            onClick={() => navigate('/manage-db-version')}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="gradient"
                            gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                            radius={6}
                            onClick={handlesave}
                            loading={detailLoading}
                        >
                            {id ? 'Update' : 'Save'}
                        </Button>
                    </SimpleGrid>
                </Box>
            </Paper>
        </>
    )
}

export default memo(AddVerticals)